import { coverLetterDataSchema, defaultCoverLetterData, idSchema } from "@reactive-resume/schema";
import { dateSchema } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { userSchema } from "../user";

export const coverLetterSchema = z.object({
  id: idSchema,
  title: z.string(),
  slug: z.string(),
  data: coverLetterDataSchema.default(defaultCoverLetterData),
  visibility: z.enum(["private", "public"]).default("private"),
  locked: z.boolean().default(false),
  userId: idSchema,
  user: userSchema.optional(),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export class CoverLetterDto extends createZodDto(coverLetterSchema) {}
